/* Home: Best Sellers carousel.
   Figma track: 327px cards on mobile and 426px cards inside a 1044px viewport
   on desktop, always at a 24px gap, so the slide width comes from CSS and
   Swiper runs in `auto` mode. */
function initHomeBestSellersSliders(root) {
  if (typeof Swiper === 'undefined') return;

  (root || document).querySelectorAll('[data-slider="home-best-sellers"]:not([data-slider-initialized])').forEach((el) => {
    el.setAttribute('data-slider-initialized', 'true');

    new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      // Horizontal trackpad swipes move the track; vertical wheel/scroll is
      // left alone so the page still scrolls past the section.
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

function destroyHomeBestSellersSliders(root) {
  (root || document).querySelectorAll('[data-slider="home-best-sellers"]').forEach((el) => {
    if (el.swiper) el.swiper.destroy(true, true);
    el.removeAttribute('data-slider-initialized');
  });
}

initHomeBestSellersSliders(document);
document.addEventListener('shopify:section:load', (event) => initHomeBestSellersSliders(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyHomeBestSellersSliders(event.target));
